import { capitalizeFirstLetter, empty, round } from '../helper'

export default {
  methods: {
    capitalizeFirstLetter,
    empty,
    round
  }
}
